import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface CmsServiceTranslation {
  _id?: ID
  cms_service_id?: ID;
  language: string;
  title: string;
  description?: string;
}

export interface CmsServiceImage {
  _id?: ID;
  url?: string;
}

export interface CmsService {
  _id?: ID;
  translations: CmsServiceTranslation[];
  image?: CmsServiceImage;
  isActive?: boolean;
  order?: number;
}

export const initialCmsService: CmsService = {
  translations: [
    { language: 'en', title: '', description: '' },
    { language: 'fr', title: '', description: '' },
  ],
  isActive: true,
  order: 0,
};

export type CmsServicesQueryResponse = Response<Array<CmsService>>;
export type QueryResponseCmsServiceContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createCmsServiceResponseContext<T>(initialState: QueryResponseCmsServiceContextProps<T>) {
  return createContext(initialState)
}
export const initialCmsServiceQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }
